import React, { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";
import { config } from "@/config";
import { getGlobalActivity } from "@/lib/api";

const short = (h) => (h ? `${h.slice(0, 6)}…${h.slice(-4)}` : "—");

export default function RecentActivity({ me }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = () =>
      getGlobalActivity(3)
        .then((d) => alive && setRows(d?.activity || []))
        .catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);
  return (
    <div data-testid="recent-activity">
      <SectionLabel center>Recent Activity</SectionLabel>
      <div className="card-glow overflow-hidden p-0">
        <div className="grid grid-cols-[1.3fr_1fr_1fr] gap-2 px-4 py-3 text-[10px] font-semibold uppercase tracking-wider text-white/40">
          <span>Label</span>
          <span>Amount</span>
          <span>Hash</span>
        </div>
        {rows.length === 0 && (
          <div className="px-4 py-4 text-center text-xs text-white/40">No activity yet</div>
        )}
        {rows.map((r, i) => {
          const href = r.hash
            ? (r.kind === "address" ? `${config.explorer}/address/${r.hash}` : `${config.explorer}/tx/${r.hash}`)
            : null;
          return (
            <div key={i} className="grid grid-cols-[1.3fr_1fr_1fr] items-center gap-2 border-t border-white/5 px-4 py-3 text-xs">
              <div>
                <div className="font-semibold text-white">{r.label}</div>
                <div className="text-[10px] text-white/40">{r.date}</div>
              </div>
              <div className="text-white/70">{r.amount}</div>
              {href ? (
                <a
                  data-testid={`activity-hash-${i}`}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-1 font-mono text-[#34D07A] transition-colors active:scale-95 hover:text-[#D6C51E]"
                >
                  {short(r.hash)}
                  <ExternalLink size={12} className="shrink-0 text-[#D6C51E]" />
                </a>
              ) : (
                <span data-testid={`activity-hash-${i}`} className="font-mono text-white/30">—</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
